import ReactMarkdown from 'react-markdown';

export const Markdown = ({ children }) => {
  return (
    <ReactMarkdown linkTarget="_blank">
      {children}
    </ReactMarkdown>
  );
};
